<template>
	<MinimalLayout>
		<LearningProfileBreak />
	</MinimalLayout>
</template>

<script setup lang="ts">
import MinimalLayout from '@/components/layout/MinimalLayout.vue';
import LearningProfileBreak from '@/components/LearningProfileBreak.vue';
</script>

